exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".k7pres-texture {\r\n    width: 67px;\r\n    height: 41px;\r\n\r\n}\r\n\r\n.k7pres-color-preview {\r\n    height: 38px;\r\n    width: 38px;\r\n\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--7-1!./node_modules/postcss-loader/lib??postcss!./src/css/positioning/presentation.css
// module id = ./node_modules/css-loader/index.js??ref--7-1!./node_modules/postcss-loader/lib/index.js??postcss!./src/css/positioning/presentation.css
// module chunks = styles